<template>
    <div id="BiometricsReportContainer">
        <div class="toggleContainer">
            <input id="compareToggle" class="tgl tgl-flat" type="checkbox" @change="toggleCompare">
            <label class="tgl-btn" for="compareToggle"></label>
        </div>
        <div class="reportContainer">
            <div class="leftCol">
                <div class="infographic"></div>
            </div>
            <div class="rightCol">
                <div class="readout">
                    <div class="field">Heartrate Variability</div>
                    <div class="val">{{hrv}}</div>
                </div>
                <div class="readout">
                    <div class="field">Blood Pressure</div>
                    <div class="val">{{bp}}</div>
                </div>
                <div class="readout">
                    <div class="field">Waist to Hip Ratio</div>
                    <div class="val">{{ratio}}</div>
                </div>
                <div class="readout">
                    <div class="field">Weight</div>
                    <div class="val">{{lbs}} lbs.</div>
                </div>
                <div class="readout comingSoon">
                    <div class="field">Posture</div>
                    <div class="val">Coming Soon</div>
                    <div class="field">Emotion</div>
                    <div class="val">Coming Soon</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'

export default {
    name: 'Intro',
    props: ['value', 'content'],
    mixins: [],
    data() {
        return {
            compare: false,
            heartRateVariability: this.content.oximeter.hrv,
            bloodPressure: this.content.oximeter.bp,
            waistHipRatio: this.content.scan.width,
            weight: this.content.scan.weight
        }
    },

    components: {
    },
    ready() {
    },
    methods: {
        toggleCompare(event) {
            this.compare = event.target.checked
            if (this.compare) {
                $('.sv_q .sv_q_title span span').text("What the numbers mean.")
                $('.sv_q .sv_q_description span span').html("Flip the toggle to just see the<br>numbers&nbsp;again.")
            } else {
                $('.sv_q .sv_q_title span span').html("The numbers.")
                $('.sv_q .sv_q_description span span').html("Flip the toggle to see what these numbers&nbsp;mean.")
            }
        }
    },

    computed: {
        hrv() {
            if (!this.compare) return this.heartRateVariability
            else return "You’re Fit!"
        },
        bp() {
            if (!this.compare) return this.bloodPressure
            else return "Great."
        },
        ratio() {
            if (!this.compare) return this.waistHipRatio
            else return "Could be better."
        },
        lbs() {
            if (!this.compare) return this.weight
            else return "Healthy-ish."
        }
    },

    watch: {
    },

    created() {
        
    },

    destroyed() {
    },

    mounted() {
        this.$nextTick(() => {
            
        })
    }

}
</script>

<style lang="scss">
@import "../styles/variables.scss";
#BiometricsReportContainer {
    
    .infographic {
        background-image: url(../assets/static/breathing_infographic.png);
        background-repeat: no-repeat;
        background-position: bottom center;
        background-size: contain;
    }
    .toggleContainer {
        margin-top: 2vw;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 30px;
        margin-bottom: 5vw;
    }
    .reportContainer {
        height: 50vh;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .leftCol {
            width: 50%;
            height: 100%;
            background-image: url(../assets/static/reportHuman.svg);
            background-repeat: no-repeat;
            background-position: bottom center;
            background-size: contain;
        }
        .rightCol {
            width: 50%;
            height: 100%;
            .readout {
                padding: 0 5vw;
                .field {
                    font-size: 2.2vw;
                    font-family: "Walsheim";
                    font-weight: 600;
                    letter-spacing: .1vw;
                    color: $color-reportBlue;
                    margin-bottom: 1vw;
                }
                .val {
                    color: $color-white;
                    font-size: 3.5vw;
                    margin-bottom: 5.7vw;
                }
                &.comingSoon {
                    padding: 5vw;
                    background-color: rgba($color-reportBlue, .35);
                    border-radius: 2vw;
                    .val, .field {
                        color: $color-blue;
                    }
                }
                &:last-child .val:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }
}

</style>